import React from 'react';
import { GalleryItem } from '@/types';
import { getMediaUrl } from '@/services/api';

interface GalleryGridProps {
  galleries: GalleryItem[];
  onGalleryClick: (gallery: GalleryItem) => void;
  className?: string;
}

const GalleryGrid: React.FC<GalleryGridProps> = ({ 
  galleries = [], // Default to empty array if undefined
  onGalleryClick, 
  className = '' 
}) => {
  // Ensure galleries is an array and has items
  const safeGalleries = Array.isArray(galleries) ? galleries : [];
  
  if (safeGalleries.length === 0) {
    return (
      <div className={`empty-state ${className}`}>
        <p>No galleries available. Check back soon for updates!</p>
      </div>
    );
  }

  return (
    <div className={`gallery-grid ${className}`}>
      {safeGalleries.map((gallery) => (
        <div 
          key={gallery.id} 
          className="gallery-card"
          onClick={() => onGalleryClick(gallery)}
        >
          <div className="gallery-preview">
            {gallery.images[0] && (
              <img 
                src={getMediaUrl(gallery.images[0])} 
                alt={gallery.title}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  // Hide the image if it fails to load
                  target.style.display = 'none';
                }}
                loading="lazy"
              />
            )}
            <div className="image-count">
              <i className="fas fa-images"></i> {gallery.images.length} photos
            </div>
          </div>
          <h3>{gallery.title}</h3>
        </div>
      ))}
    </div>
  );
};

export default GalleryGrid;
